
<div class="container mt-2 mb-4">
<button class="botao-primario" [ngClass]="{'w-100' : size === '100'}">{{textButton}}</button>
</div>
